import { Controller } from 'stimulus'
import './component.scss'

// 共通画像ディレクトリから参照
import 'Images/nurikae_site/staff_introduction/819_arai_sora.webp'
import 'Images/nurikae_site/staff_introduction/819_arai_kaneyasu.webp'
import 'Images/nurikae_site/staff_introduction/819_yokoyama.webp'
import 'Images/nurikae_site/staff_introduction/831_sunada.webp'
import 'Images/nurikae_site/staff_introduction/1651_asami.jpg'
import 'Images/nurikae_site/staff_introduction/1651_ikeda.jpg'
import 'Images/nurikae_site/staff_introduction/1651_kanto.jpg'
import 'Images/nurikae_site/staff_introduction/1651_kida.jpg'
import 'Images/nurikae_site/staff_introduction/1651_koyama.jpg'
import 'Images/nurikae_site/staff_introduction/1651_kuroda.jpg'
import 'Images/nurikae_site/staff_introduction/1651_moriyama.jpg'
import 'Images/nurikae_site/staff_introduction/1651_obuchi.jpg'
import 'Images/nurikae_site/staff_introduction/1651_oigawa.jpg'
import 'Images/nurikae_site/staff_introduction/1997_ninomiya.webp'
import 'Images/nurikae_site/staff_introduction/1997_odate.webp'
import 'Images/nurikae_site/staff_introduction/1997_ozawa.webp'
import 'Images/nurikae_site/staff_introduction/1997_sato.webp'
import 'Images/nurikae_site/staff_introduction/1997_shirai.webp'
import 'Images/nurikae_site/staff_introduction/1997_shirakura.webp'
import 'Images/nurikae_site/staff_introduction/1997_yamakawa.webp'
import 'Images/nurikae_site/staff_introduction/2075_kamishita.webp'
import 'Images/nurikae_site/staff_introduction/2290_chuma.webp'
import 'Images/nurikae_site/staff_introduction/390_iwabuchi.webp'
import 'Images/nurikae_site/staff_introduction/390_tomaru.jpg'
import 'Images/nurikae_site/staff_introduction/3737_ariga.jpg'
import 'Images/nurikae_site/staff_introduction/3737_fuchu.jpg'
import 'Images/nurikae_site/staff_introduction/3737_hanyu.webp'
import 'Images/nurikae_site/staff_introduction/3737_imai.jpg'
import 'Images/nurikae_site/staff_introduction/3737_ishida.jpg'
import 'Images/nurikae_site/staff_introduction/3737_kokubun.webp'
import 'Images/nurikae_site/staff_introduction/3737_kono.jpg'
import 'Images/nurikae_site/staff_introduction/3737_nakano_s.jpg'
import 'Images/nurikae_site/staff_introduction/3737_nakano_y.jpg'
import 'Images/nurikae_site/staff_introduction/3737_okada.jpg'
import 'Images/nurikae_site/staff_introduction/3737_rikimaru.jpg'
import 'Images/nurikae_site/staff_introduction/3737_sato.jpg'
import 'Images/nurikae_site/staff_introduction/3737_sekine.jpg'
import 'Images/nurikae_site/staff_introduction/3737_yamaguchi.webp'
import 'Images/nurikae_site/staff_introduction/3737_yoshida.webp'
import 'Images/nurikae_site/staff_introduction/4611_usui.webp'
import 'Images/nurikae_site/staff_introduction/4611_yoshida.webp'
import 'Images/nurikae_site/staff_introduction/4834_harada.webp'
import 'Images/nurikae_site/staff_introduction/5089_hanawa.webp'
import 'Images/nurikae_site/staff_introduction/5089_miyanaga.webp'
import 'Images/nurikae_site/staff_introduction/5325_nakamura.webp'
import 'Images/nurikae_site/staff_introduction/5325_sano.webp'
import 'Images/nurikae_site/staff_introduction/5594_kobayashi.webp'

class StaffIntroductionSpController extends Controller {
  static targets = [
    'track',
    'scrollbarThumb',
    'modal',
    'modalScrollContent',
    'modalScrollbarThumb',
    'image'
  ]

  connect() {
    this.updateScrollbar()
    this.bindImageLoad()
    this.initModalScrollbars()
  }

  // カード横スクロールバー
  updateScrollbar() {
    if (!this.hasTrackTarget || !this.hasScrollbarThumbTarget) return

    requestAnimationFrame(() => {
      const scrollWidth = this.trackTarget.scrollWidth
      const clientWidth = this.trackTarget.clientWidth
      const scrollLeft = this.trackTarget.scrollLeft
      const maxScroll = scrollWidth - clientWidth

      if (maxScroll <= 0) {
        this.scrollbarThumbTarget.style.width = '100%'
        this.scrollbarThumbTarget.style.left = '0%'
        return
      }

      const thumbWidth = (clientWidth / scrollWidth) * 100
      const thumbLeft = (scrollLeft / maxScroll) * (100 - thumbWidth)

      this.scrollbarThumbTarget.style.width = `${thumbWidth}%`
      this.scrollbarThumbTarget.style.left = `${thumbLeft}%`
    })
  }

  onScroll() {
    this.updateScrollbar()
  }

  onResize() {
    this.updateScrollbar()
    this.modalScrollContentTargets.forEach((scrollContent) => {
      this.updateModalScrollbar(scrollContent)
    })
  }

  bindImageLoad() {
    if (!this.hasImageTarget) return

    this.imageTargets.forEach((img) => {
      if (img.complete) {
        this.updateScrollbar()
      } else {
        img.addEventListener('load', () => this.updateScrollbar())
      }
    })
  }

  // モーダル開閉
  openModal(event) {
    const modalId = event.currentTarget.dataset.modalId
    const dialog = document.getElementById(modalId)
    if (dialog) {
      dialog.showModal()
      dialog.setAttribute('data-activate', 'true')
      // モーダルを開いた後にスクロールバーを更新
      setTimeout(() => {
        const scrollContent = dialog.querySelector('.staff-introduction-sp-modal__scroll-content')
        if (scrollContent) {
          this.updateModalScrollbar(scrollContent)
        }
      }, 100)
    }
  }

  closeModal(event) {
    const dialog = event.currentTarget.closest('dialog')
    if (dialog) {
      this.closeDialog(dialog)
    }
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.closeDialog(event.currentTarget)
    }
  }

  async closeDialog(dialog) {
    dialog.setAttribute('data-activate', 'false')
    await this.waitAnimation(dialog)
    dialog.close()
  }

  waitAnimation(element) {
    return Promise.allSettled(
      Array.from(element.getAnimations()).map((animation) => animation.finished)
    )
  }

  // モーダル内スクロールバー
  initModalScrollbars() {
    this.modalTargets.forEach((modal) => {
      const scrollContent = modal.querySelector('.staff-introduction-sp-modal__scroll-content')
      if (scrollContent) {
        // モーダルの属性変更を監視
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open' || mutation.attributeName === 'data-activate') {
              setTimeout(() => this.updateModalScrollbar(scrollContent), 100)
            }
          })
        })
        observer.observe(modal, { attributes: true })
      }
    })
  }

  onModalScroll(event) {
    this.updateModalScrollbar(event.currentTarget)
  }

  updateModalScrollbar(scrollContent) {
    const modal = scrollContent.closest('.staff-introduction-sp-modal')
    if (!modal) return

    const thumb = modal.querySelector('.staff-introduction-sp-modal__scrollbar-thumb')
    if (!thumb) return

    requestAnimationFrame(() => {
      const scrollHeight = scrollContent.scrollHeight
      const clientHeight = scrollContent.clientHeight
      const scrollTop = scrollContent.scrollTop
      const maxScroll = scrollHeight - clientHeight

      if (maxScroll <= 0) {
        thumb.style.height = '100%'
        thumb.style.top = '0%'
        return
      }

      const thumbHeight = (clientHeight / scrollHeight) * 100
      const thumbTop = (scrollTop / maxScroll) * (100 - thumbHeight)

      thumb.style.height = `${thumbHeight}%`
      thumb.style.top = `${thumbTop}%`
    })
  }
}

// StimulusJSに登録
window.Stimulus.register('staff-introduction-sp', StaffIntroductionSpController)
